import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-back-wall',
  templateUrl: './back-wall.component.html',
  styleUrls: ['./back-wall.component.scss']
})
export class BackWallComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
